import { rem } from 'polished'
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { UserPreferenceDestination, UserPreferenceHolidayOrBrands } from '../types'
import TravelPreferencesDestinationOptionItem from './TravelPreferencesDestinationOptionItem'
import TravelPreferencesOptionItem from './TravelPreferencesOptionItem'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled.div`
  display: grid;
  column-gap: ${rem(16)};
  row-gap: ${rem(24)};
  grid-template-columns: repeat(2, minmax(0, 1fr));

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(auto-fill, minmax(${rem(192)}, 1fr));
  }
`

const isDestinationItem = (item: UserPreferenceHolidayOrBrands | UserPreferenceDestination): item is UserPreferenceDestination => {
  return 'placeId' in item
}

interface Props {
  showLabel?: boolean
  items: Array<UserPreferenceHolidayOrBrands | UserPreferenceDestination>
  onSelect: (selection: UserPreferenceHolidayOrBrands | UserPreferenceDestination) => void
  selectedId: Set<string>
}

function TravelPreferencesOptionsGrid(props: Props) {
  const { showLabel = true, items, onSelect, selectedId } = props

  return <Container>
    {items.map((item) => <Fragment key={isDestinationItem(item) ? item.placeId : item.id}>
      {isDestinationItem(item) && <TravelPreferencesDestinationOptionItem
        item={item}
        isSelected={selectedId.has(item.placeId)}
        onSelect={onSelect}
        showLabel={showLabel}
      />}
      {!isDestinationItem(item) && <TravelPreferencesOptionItem
        item={item}
        isSelected={selectedId.has(item.id)}
        onSelect={onSelect}
        showLabel={showLabel}
      />}
    </Fragment>)}
  </Container>
}

export default TravelPreferencesOptionsGrid
